import { type SearchRequest } from '@searchkit/api';

import {
  createResponseFactory,
  type PremiumMarketMoversSearchResponseBody,
} from '~/apps/product-plus/search-domain/pipelines/premium-market-movers/response-factory';
import { type SearchDomainContext } from '~/apps/product-plus/search-domain/types';
import { createElasticSearchContext, createResponseFactoryContext } from '~/apps/product-plus/search-domain/utils';

export async function transformPremiumMarketMoversResponse(
  context: SearchDomainContext,
  { searchResponse }: { searchRequest: SearchRequest; searchResponse: PremiumMarketMoversSearchResponseBody },
) {
  const elasticContext = createElasticSearchContext(context);

  return createResponseFactory.call(createResponseFactoryContext(context), elasticContext, searchResponse);
}
